var map = {
	"./benefits-desktop.png": 8548,
	"./benefits-mobile.png": 1105,
	"./day-schedule.png": 9830,
	"./feat-reports-desktop.png": 1439,
	"./feat-reports-mobile.png": 2401,
	"./innovation-product.png": 6193,
	"./patient-galery-mobile.png": 4860,
	"./patient-hist-cli-mobile.png": 4152,
	"./patient-odontogram-mobile.png": 4630,
	"./patient-payments-mobile.png": 8966,
	"./patient-product.png": 7106,
	"./patient-recipes-desktop.png": 876,
	"./patient-recipes-mobile.png": 4926,
	"./patient-schedule-mobile.png": 8581,
	"./prof-schedule.png": 5348,
	"./purposes-desktop.png": 8592,
	"./purposes-mobile.png": 6149,
	"./schedule-product.png": 7343,
	"./shield-card1.png": 2948,
	"./shield-card2.png": 1688,
	"./shield-card3.png": 8119,
	"./shield.png": 9181,
	"./statistics-experience.png": 810,
	"./statistics-product.png": 7776,
	"./weekly-schedule.png": 8906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8027;